import Device from './device'
import DeviceLog from './device_log'
import DeviceModbus from './device_modbus'
import Farm from './farm'
import Gpio from './gpio'
import ModbusIo from './modbus_io'
import User from './user'
import WhiteList from './whitelist'
import Gateway from './gateway'
import EspNowDevice from './espnow_device'
import Dashboard from './dashboard'
import Widget from './widget'
import DeviceOverload from './device_overload'
import IoExtension from './io_extension'


export default {
  DeviceApi: Device,
  DeviceLogApi: DeviceLog,
  DeviceModbusApi: DeviceModbus,
  FarmApi: Farm,
  GpioApi: Gpio,
  ModbusIoApi: ModbusIo,
  UserApi: User,
  WhiteListApi: WhiteList,
  GatewayApi: Gateway,
  EspNowDeviceApi: EspNowDevice,
  DashboardApi: Dashboard,
  WidgetApi: Widget,
  DeviceOverloadApi: DeviceOverload,
  IoExtensionApi: IoExtension
}
